import React from 'react';
import Text from '@amzn/meridian/text';
import './pageNotFound.scss';

const pageNotFound = () => {
  return (
    <div className="page-not-found">
      <Text type="d50">Sorry, this page does not exist</Text>
    </div>
  );
};

export default pageNotFound;
